import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

export default function NotFound(params) {
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2,
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              {params.title || "404 - Page Not Found"}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
